/* eslint-disable no-restricted-properties */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useContext, useCallback, useState } from 'react';
import { isAfter, parseJSON, addHours } from 'date-fns';
import { useHistory } from 'react-router-dom';
import api from '../services/api';
import AuthService, { AutenticateCredentials } from '../services/auth';

interface Token {
  access_token: string;
  token_type: string;
  expires_in: number;
  'as:Client-Id': string;
  '.issued': string;
  '.expires': string;
}

interface AuthContextData {
  token: Token;
  signInToken: any;
  signIn(credentials: AutenticateCredentials): Promise<void>;
  signOut(): void;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

interface IAuthProvider {
  children: React.ReactNode;
}

const AuthProvider: React.FC<IAuthProvider> = ({ children }) => {
  const { push } = useHistory();

  const services = { AuthService: new AuthService() };

  const [token, setToken] = useState<Token>(() => {
    const stringToken = localStorage.getItem('@TransfacilPJ:token');

    if (stringToken) {
      const parsedToken = JSON.parse(stringToken);
      const AddedNow = addHours(new Date(), 3);
      const isExpired = isAfter(parseJSON(AddedNow), parsedToken['.expires']);
      if (isExpired) {
        localStorage.removeItem('@TransfacilPJ:token');
        localStorage.removeItem('@TransfacilPJ:user');
        push('/');
        return {} as Token;
      }
      api.defaults.headers.token = parsedToken.access_token;
      return parsedToken;
    }
    return {} as Token;
  });

  const signIn = useCallback(
    async ({ username, password }: any) => {
      const response = await services.AuthService.autenticate({
        username,
        password,
      });
      console.log(response.data);

      api.defaults.headers.token = response.data.access_token;

      setToken(response.data);

      localStorage.setItem(
        '@TransfacilPJ:token',
        JSON.stringify(response.data),
      );

      push('/meu-perfil');
    },
    [push],
  );

  const signInToken = useCallback(
    async (data: any) => {
      api.defaults.headers.token = data?.access_token;

      setToken(data);

      localStorage.setItem('@TransfacilPJ:token', JSON.stringify(data));

      push('/meu-perfil');
    },
    [push],
  );

  const signOut = useCallback(async () => {
    localStorage.removeItem('@TransfacilPJ:token');
    localStorage.removeItem('@TransfacilPJ:user');
    localStorage.removeItem('DataFilter');
    setToken({} as Token);
  }, []);

  return (
    <AuthContext.Provider value={{ token, signIn, signInToken, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

function useAuth(): AuthContextData {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth só pode ser usado dentro de um AuthProvider');
  }

  return context;
}

export { AuthProvider, useAuth };
